export const formatterFunctions = {
    progressBarFormatter: (value, context) => {
          if (context.chart.options.plugins.centerBarLabels.ccShowProgressAsPercentage) {
            const max = context.chart.options.scales.x.max
            const min = context.chart.options.scales.x.min
            if (min === 0 && max === 100) {
              //it is already a percentage, nothing to calculate we just add a %
              return `${Math.round(value)}%`
            }
            else {
              const result = (value - min) / (max - min) * 100
              //const result = value * 100 / max
              return `${Math.round(result)}%`
            }

          }
          return `${value}`;
        }
}

export const ApplyFormatterFunction = (metadata) => {
  console.log(metadata)
  switch (metadata.selectedChartId) {
    case "Progress Bar":
      if(metadata.options.plugins.centerBarLabels) {
        metadata.options.plugins.centerBarLabels.formatter = formatterFunctions.progressBarFormatter
      }
      break
    default:
      break
  }
}